import { createSignal, type ParentComponent } from "solid-js"
import { Portal } from "solid-js/web"

const [headerElement, setHeaderElement] = createSignal<HTMLDivElement | null>(null)

export const HeaderTarget: ParentComponent = () => {
  return <div ref={setHeaderElement} class="flex items-center gap-2 flex-1 justify-center px-4 min-w-0 overflow-x-auto" />
}

export const HeaderSlot: ParentComponent = (props) => {
  const el = headerElement()
  return (
    <>{el && <Portal mount={el}>{props.children}</Portal>}</>
  )
}
